import { Component, OnDestroy, EventEmitter, Output, inject, ChangeDetectionStrategy } from "@angular/core";
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";

import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-fleetwide-ops",
	templateUrl: "./fleetwide-ops.component.html",
	styleUrls: ["./fleetwide-ops.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [RouterLink, RouterLinkActive, RouterOutlet]
})
export class FleetwideOpsComponent implements OnDestroy {
	api = inject(ApiService);
	private router = inject(Router);

	@Output()
	public AssetSelected = new EventEmitter<APIResults.Asset>();

	private activeRouteComponent: any;

	ngOnDestroy(): void {
		this.selectedSubscription?.unsubscribe();
	}

	private selectedSubscription: any;
	public updateRouterOutlet(routecomponent?: any) {
		this.selectedSubscription?.unsubscribe();
		if (routecomponent) {
			this.activeRouteComponent = routecomponent;
		}
		if (this.activeRouteComponent) {
			// Pass the AssetSelected event up to the parent
			if (this.activeRouteComponent.AssetSelected) {
				this.selectedSubscription = this.activeRouteComponent.AssetSelected.subscribe(async (asset: APIResults.Asset) => {
					this.AssetSelected.emit(asset);
				});
			}
		}
	}
}